import React from 'react'
import { Box, Typography } from '@mui/material'
import { unstable_useId as useId } from '@mui/material/utils'
import { advancedColors } from '../theme'

const AdvancedConfigSection = ({
  title,
  children,
  maxWidth = 960,
}: {
  title: string
  children: React.ReactNode
  maxWidth?: number
}) => {
  const headingId = useId()

  return (
    <Box
      component="section"
      aria-labelledby={headingId}
      sx={{
        width: '100%',
        maxWidth,
        minWidth: 0,
        transition: (theme) =>
          theme.transitions.create('max-width', { duration: 300, easing: theme.transitions.easing.easeInOut }),
        '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
      }}
    >
      <Typography
        component="h2"
        variant="h3"
        id={headingId}
        sx={{ color: advancedColors.ink, borderBottom: `1px solid ${advancedColors.line}`, py: 1.5 }}
      >
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>{children}</Box>
    </Box>
  )
}

export default AdvancedConfigSection
